var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"tag":"button","to":("/l/" + (Number(_vm.$route.params.level) + 1))}},[_vm._v("\n  Next level\n")])}
var staticRenderFns = []

export { render, staticRenderFns }